/** Scaling knobs one difficulty step carries (run/sector-hooks.ts reads them). */
export interface DifficultyStep {
  /** Boss HP after the firepower scaling */
  readonly enemyHp: number;
  /** Every hit the ship takes (bullets, contact, lava) */
  readonly enemyDamage: number;
  /** Light-squad size per wave */
  readonly waveDensity: number;
  /** Share of light-squad members promoted to elites (0..1) */
  readonly eliteRatio: number;
  /** Boss yellow + red payouts (fresh builds must still ramp in 7 rooms) */
  readonly economy: number;
}

/** A sector row also sets the boss level ramp (endless: GAME.run.bossLevel). */
export interface SectorDifficulty extends DifficultyStep {
  /** Boss level = base + floor(roomInSector * perRoom) (+ finale levels) */
  readonly bossLevel: { readonly base: number; readonly perRoom: number };
  /** Hull at the sector start: S1 keeps the wounded tutorial launch (repair
   *  is the first goal), later sectors open on tier 1-3 bosses at full hull */
  readonly startHp: number;
}

/**
 * Difficulty multipliers (EPIC D2). Every scaling passes through
 * `difficultyFor` (run/sector-hooks.ts): endless runs use `base` (the
 * identity — endless plays exactly as before), sector runs use their row
 * of `sectors` (same index as config/sectors.ts). Calibrated with the
 * headless duration sim (docs/01 duration calibration).
 */
export const DIFFICULTY: {
  readonly base: DifficultyStep;
  readonly sectors: ReadonlyArray<SectorDifficulty>;
} = {
  base: {
    enemyHp: 1,
    enemyDamage: 1,
    waveDensity: 1,
    eliteRatio: 0,
    economy: 1,
  },
  sectors: [
    {
      enemyHp: 1.88, enemyDamage: 1, waveDensity: 1.2, eliteRatio: 0, economy: 1,
      bossLevel: { base: 1, perRoom: 0.85 }, startHp: 25,
    },
    {
      enemyHp: 1.24, enemyDamage: 1.1, waveDensity: 1.1, eliteRatio: 0.06, economy: 1.15,
      bossLevel: { base: 6, perRoom: 0.85 }, startHp: 100,
    },
    {
      enemyHp: 1.12, enemyDamage: 1.2, waveDensity: 1.2, eliteRatio: 0.12, economy: 1.3,
      bossLevel: { base: 11, perRoom: 0.85 }, startHp: 100,
    },
    {
      enemyHp: 0.86, enemyDamage: 1.3, waveDensity: 1.3, eliteRatio: 0.18, economy: 1.45,
      bossLevel: { base: 16, perRoom: 0.85 }, startHp: 100,
    },
  ],
};
